export const XS = 320;
export const SM = 400;
export const MD = 699;
export const LG = 992;
export const XL = 1312;
export const XXL = 1599;

export default {
  XS,
  SM,
  MD,
  LG,
  XL,
  XXL,
} as const;
